import { Container, Button, Row, Col } from "reactstrap";
import {
    FaGolfBall,
    FaClock,
    FaCalendarAlt,
    FaDollarSign,
} from "react-icons/fa";
import styles from "../../styles/public/confirm-page.module.css";

const ConfirmSelection = ({ bookingData, onConfirm, onCancel }) => {

    const formatDate = (date) => {
        if (!date) return "Not selected";
        const dateObj = new Date(date);
        const day = dateObj.getDate();
        const month = dateObj.toLocaleDateString("en-US", { month: "long" });
        return `${month} ${day}${getDaySuffix(day)}`;
    };

    const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return "th";
        switch (day % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };

    const cost = bookingData.total;

    return (
        <Container className={`${styles["confirm-container"]} py-4`}>
            <div className="text-center mb-4 border-bottom">
                <div className={styles["confirm-title"]}>Please confirm your selection</div>
            </div>

            <Row className="mb-4 pb-3">
                <Col xs={12} md={4} className="mb-3 mb-md-0">
                    <h3 className={styles["confirmation-details-title"]}>Reservation Details</h3>
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-center gap-2">
                            <FaGolfBall />
                            <span>{bookingData.service?.title || "Custom"}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <FaClock />
                            <span>{formatDate(bookingData.date)}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            <span>{bookingData.time || "Not set"}</span>
                        </div>
                        {cost && cost !== 0 && <div className="d-flex align-items-center gap-2">
                            <FaDollarSign />
                            <span>{parseFloat(cost).toFixed(2)} (due at check in)</span>
                        </div>}
                    </div>
                </Col>
                <Col xs={12} md={8} className="d-flex justify-content-center align-items-center">
                    <Container className="border p-4 bg-light rounded">
                        <Row className="mb-3" xs={12}>
                            <Col className="text-center">
                            Are you sure you want to change your league round?
                            </Col>
                        </Row>
                        <Row xs={12}>
                            <Col className="text-center gap-2 d-flex justify-content-center">
                                <Button className={styles["cancel-button"]} onClick={onConfirm}>
                                    Yes
                                </Button>
                                <Button className={styles["cancel-button"]} onClick={onCancel}>
                                    No
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

        </Container>
    );
};

export default ConfirmSelection;